export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-950 text-background-100 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-semibold uppercase tracking-wider mb-5">
              / VigorBuy Sheet
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 tracking-tight leading-tight">
              Why Thousands of Users Choose VigorBuy Spreadsheet
            </h2>
            <p className="mt-6 text-base text-background-300 leading-relaxed max-w-lg">
              The VigorBuy Spreadsheet has become the easiest way to organize products, compare options, and discover useful buying information. Our platform provides structured resources that make shopping faster, smarter, and more enjoyable.
            </p>

            <ul className="mt-8 space-y-4">
              {[
                { icon: 'ri-database-2-line', text: 'Updated spreadsheet resources refreshed weekly' },
                { icon: 'ri-booklet-line', text: 'Detailed category guides for all 14 categories' },
                { icon: 'ri-table-line', text: 'Comparison tables for side-by-side evaluation' },
                { icon: 'ri-shield-star-line', text: 'Safety recommendations and buying tips' },
                { icon: 'ri-graduation-cap-line', text: 'Beginner tutorials for new shoppers' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-md bg-accent-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-accent-300 text-sm`}></i>
                  </div>
                  <span className="text-sm text-background-200 leading-relaxed pt-1.5">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20tablet%20device%20displaying%20organized%20product%20catalog%20interface%20with%20warm%20ambient%20light%20on%20natural%20linen%20desk%20surface%2C%20minimalist%20workspace%20photography%2C%20soft%20diffused%20window%20lighting%20casting%20gentle%20shadows%2C%20editorial%20technology%20lifestyle%20aesthetic%2C%20warm%20beige%20and%20sand%20tones%2C%20clean%20modern%20composition%20with%20dried%20botanical%20accent%2C%20sophisticated%20home%20office%20atmosphere&width=800&height=800&seq=about-vigorbuy-v2-2026&orientation=squarish"
                alt="VigorBuy Spreadsheet interface on tablet"
                className="w-full h-full object-cover object-center"
                title="VigorBuy Spreadsheet - Organized Shopping Resource"
              />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-background-50 rounded-lg p-6 border border-background-200">
              <div className="flex flex-col items-center">
                <span className="font-heading text-5xl font-bold text-foreground-950">10K+</span>
                <span className="text-sm text-foreground-600 mt-1">Active Readers</span>
              </div>
              <div className="grid grid-cols-3 gap-4 mt-4 pt-4 border-t border-background-200">
                <div className="text-center">
                  <span className="block font-heading text-lg font-bold text-foreground-950">100+</span>
                  <span className="text-[11px] text-foreground-500">Guides</span>
                </div>
                <div className="text-center">
                  <span className="block font-heading text-lg font-bold text-foreground-950">30+</span>
                  <span className="text-[11px] text-foreground-500">Articles</span>
                </div>
                <div className="text-center">
                  <span className="block font-heading text-lg font-bold text-foreground-950">14</span>
                  <span className="text-[11px] text-foreground-500">Categories</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20">
          <h3 className="font-heading text-2xl font-bold text-background-50 text-center mb-10 tracking-tight">
            VigorBuy Spreadsheet vs Traditional Search
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full max-w-3xl mx-auto text-left">
              <thead>
                <tr className="border-b border-background-700">
                  <th className="py-4 pr-8 text-sm font-semibold text-background-50 whitespace-nowrap">Feature</th>
                  <th className="py-4 pr-8 text-sm font-semibold text-accent-300 whitespace-nowrap">VigorBuy Spreadsheet</th>
                  <th className="py-4 text-sm font-semibold text-background-400 whitespace-nowrap">Traditional Search</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Product Discovery', vigorbuy: 'Excellent', traditional: 'Moderate' },
                  { feature: 'Organization', vigorbuy: 'Excellent', traditional: 'Poor' },
                  { feature: 'Time Saving', vigorbuy: 'High', traditional: 'Low' },
                  { feature: 'Updates', vigorbuy: 'Frequent', traditional: 'Limited' },
                  { feature: 'User Experience', vigorbuy: 'Better', traditional: 'Average' },
                ].map((row) => (
                  <tr key={row.feature} className="border-b border-background-800/50">
                    <td className="py-4 pr-8 text-sm text-background-200 whitespace-nowrap font-medium">{row.feature}</td>
                    <td className="py-4 pr-8">
                      <span className="inline-flex items-center gap-1.5 text-sm text-accent-300 whitespace-nowrap">
                        <i className="ri-check-line text-xs"></i>
                        {row.vigorbuy}
                      </span>
                    </td>
                    <td className="py-4">
                      <span className="text-sm text-background-500 whitespace-nowrap">{row.traditional}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}